module.exports = __webpack_public_path__ + "img/arrow_left_square.ea450643.svg";